import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useModal } from '@/components/modal/useModal';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useBundle } from '@/services/bundles/useBundleService';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent } from 'react';
import { useNavigate, useParams } from 'react-router';
import CreateEditBundleForm, { CreateEditBundleSubmitData } from './CreateEditBundleForm';
import DeleteBundleModal from './DeleteBundleModal';

interface EditBundleProps {}

const EditBundle: FunctionComponent<EditBundleProps> = () => {
  const { id } = useParams();
  if (!id) throw new Error('Missing bundle id');

  const getBundleById = useBundle(state => state.getBundleById);

  const bundle = getBundleById(id);

  if (!bundle) throw new Error('Missing bundle');

  const routePrefix = useCustomerRoutePrefix();
  const myBundlePageRoute = `${routePrefix}/bundles`;

  const navigate = useNavigate();

  const breadcrumbs: NavPage[] = [
    {
      name: 'Bundles',
      to: myBundlePageRoute
    },
    {
      name: `Edit Bundle ${bundle.name}`,
      to: ``
    }
  ];

  const editBundle = useBundle(state => state.editBundle);

  const onSubmit = async (data: CreateEditBundleSubmitData) => {
    await editBundle({
      id: bundle.id,
      name: data.name,
      bundledItems: data.peripherals.map(peripheral => {
        return {
          catalogItem: peripheral.id,
          count: peripheral.count
        };
      })
    });
    navigate(myBundlePageRoute);
  };

  const deleteBundleModalProps = useModal<{ bundleId: string }>();

  return (
    <>
      <DeleteBundleModal {...deleteBundleModalProps} />
      <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
        <CataloguePageHeader title={bundle.name} breadcrumbs={breadcrumbs}>
          <div className="flex gap-4">
            {/*<HelpButton />*/}
            <Button
              onClick={() => {
                navigate(myBundlePageRoute);
              }}
              variant={ButtonVariant.Mono}
            >
              <SiChevronLeft className="text-xl" />
              <span>Back to Bundle Overview</span>
            </Button>
            <Button
              onClick={() => {
                deleteBundleModalProps.open({ bundleId: id });
              }}
              variant={ButtonVariant.Secondary}
            >
              <span>Delete Bundle</span>
            </Button>
          </div>
        </CataloguePageHeader>

        <CreateEditBundleForm key={bundle.id} bundle={bundle} onSubmitCallback={onSubmit} />
      </div>
    </>
  );
};

export default EditBundle;
